<template>
  <v-layout class="mb-2" justify-space-between>
<!--        Back buttons-->
    <div>
      <v-btn
        data-testid="rent-dismiss-btn"
        class="rent-dismiss-btn mt-2 ml-3"
        v-if="currentStep === 6"
        color="error"
        @click.native="success"
        large
      >
        Dismiss
      </v-btn>
      <v-btn
        data-testid="rent-close-btn"
        class="rent-close-btn mt-2 ml-3"
        v-else
        color="error"
        @click.native="collapse"
        :disabled="!recording"
        large
      >
        Close
      </v-btn>
    </div>
<!--        Forward Buttons-->
    <div>
      <v-btn
        data-testid="rent-to-select-unit-btn"
        class="rent-to-select-unit-btn mt-2 mr-3 primary"
        v-if="currentStep == 0"
        :loading="loading"
        color="primary"
        large
        @click.native="unitUpdated"
        :disabled="!newUnitSelected"
      >
        Select Unit
      </v-btn>
      <v-btn
        data-testid="rent-to-lease-info-btn"
        class="rent-to-lease-info-btn mt-2 mr-3 primary"
        v-if="currentStep === 1"
        :loading="loading"
        color="primary"
        large
        @click.native="toLease"
        :disabled="!customerInfoValid"
      >
        Enter Lease Info
      </v-btn>
      <v-btn
        data-testid="rent-move-in-instructions-btn"
        class="rent-move-in-instructions-btn mt-2 mr-3 primary"
        v-if="currentStep === 2"
        :loading="loading"
        color="primary"
        @click.native="toMoveIn"
        :disabled="!leaseInfoValid"
        large
      >
        Move-In Instructions
      </v-btn>
      <div>
        <v-btn
          data-testid="speederent-btn"
          class="speederent-btn mt-2 mr-3 success"
          v-if="currentStep === 3 && speederentBtnEnabled"
          :loading="loading"
          color="primary"
          large
          @click.native="speederent"
        >
          Speederent
        </v-btn>
        <v-btn
          data-testid="rent-to-add-merchandise-btn"
          class="rent-to-add-merchandise-btn mt-2 mr-3 primary"
          v-if="currentStep === 3"
          :loading="loading"
          color="primary"
          large
          @click.native="toMerch"
        >
          Add Merchandise
        </v-btn>

      </div>
      <v-btn
        data-testid="rent-to-take-payment-btn"
        class="rent-to-take-payment-btn mt-2 mr-3 primary"
        v-if="currentStep === 4"
        :loading="loading"
        color="primary"
        large
        @click.native="toPayment"
      >
        Take Payment
      </v-btn>
      <v-btn
        data-testid="rent-to-view-summary-btn"
        class="rent-to-view-summary-btn mt-2 mr-3 primary"
        v-if="currentStep === 5"
        :loading="loading"
        color="primary"
        large
        @click.native="toSummary"
        :disabled="!canSubmit || !recording"
      >
        View Summary
      </v-btn>
      <v-btn
        data-testid="rent-to-submit-move-in-btn"
        class="rent-to-submit-move-in-btn mt-2 mr-3"
        v-if="currentStep === 6"
        :loading="paymentLoading"
        color="success"
        large
        @click.native="moveIn"
      >
        Submit
      </v-btn>
      <disposition
        v-if="currentStep === 7"
        :dispositionOpen="dispositionOpen"
        @collapse="dispositionOpen = false"
      >
        <v-btn
          data-testid="rent-disposition-btn"
          class="rent-disposition-btn mt-2 mr-3"
          color="primary"
          large
          @click.stop="dispositionOpen = true"
        >
          Disposition
        </v-btn>
      </disposition>
    </div>
  </v-layout>
</template>

<script>
import Disposition from "@/components/Disposition";
import { EventBus } from "@/Event";
import { mapState } from "vuex";
export default {
  name: "StepperNavigation",
  components: { Disposition },
  props: {
    currentStep: {
      type: [Number, String],
      default: 1
    },
    loading: {
      type: Boolean,
      default: false
    },
    newUnitSelected: {
      type: Boolean,
      default: false
    },
    paymentLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dispositionOpen: false,
      speederentBtnEnabled: false
    };
  },
  methods: {
    success() {
      this.$emit("success");
    },
    collapse() {
      if (this.currentStep >= 6) {
        EventBus.$emit("reloadCurrentFacility");
      }
      this.$emit("collapse");
    },
    unitUpdated() {
      this.$emit("unitUpdated");
    },
    toLease() {
      this.$emit("toLease");
    },
    toMoveIn() {
      this.$emit("toMoveIn");
    },
    speederent() {
      this.$emit("speederent");
    },
    toMerch() {
      this.$emit("toMerch");
    },
    toPayment() {
      this.$emit("toPayment");
    },
    toSummary() {
      this.$emit("toSummary");
    },
    moveIn() {
      this.$emit("moveIn");
    }
  },
  computed: {
    speederentEnabled() {
      if (!this.$store.state.settings) return;
      if (!this.$store.state.settings.settings) return;
      return this.$store.state.settings.settings.find(setting => setting.label === "Speederent");
    },
    ...mapState({
      creditCard: state => state.tenant.creditCard,
      info: state => state.tenant.info,
      lease: state => state.tenant.lease,
      recording: state => state.call.recording
    }),
    customerInfoValid() {
      if (
        this.$store.state.reservations.invalidPromotion === true &&
        (
          !this.$store.state.tenant.options ||
          (
            !this.$store.state.tenant.options.selectedPromotion &&
            this.$store.state.tenant.options.selectedPromotion !== 0
          )
        )
      ) {
        return false;
      }

      // For Drivers License or State ID, an ID *state* is also required.
      if (this.info.id_type === "1" || this.info.id_type === "2") {
        if (!this.info.id_state) {
          return false;
        }
      }

      if (this.info.is_business) {
        return !!(this.validCriteria && this.info.business_name);
      }
      return !!(this.validCriteria);
    },
    leaseInfoValid() {
      return true;
    },
    canSubmit() {
      return !!(this.currentStep === 5 && this.cardValid);
    },
    cardValid() {
      if (!this.creditCard.firstName) return false;
      if (!this.creditCard.lastName) return false;
      if (!this.creditCard.billingAddress) return false;
      if (!this.creditCard.billingState) return false;
      if (this.creditCard.billingZip.length !== 5) return false;
      if (!this.creditCard.ccType) return false;
      /* spaces added for readability.  For validation, remove them */
      if (this.cardIsAmex && this.creditCard.ccNumber.replace(/\s/g, "").length !== 15) return false;
      if (!this.cardIsAmex && this.creditCard.ccNumber.replace(/\s/g, "").length !== 16) return false;
      if (!this.creditCard.ccExpirationMonth) return false;
      if (!this.creditCard.ccExpirationYear) return false;
      if (this.cardIsAmex && this.creditCard.ccCVV.length !== 4) return false;
      if (!this.cardIsAmex && this.creditCard.ccCVV.length !== 3) return false;
      return true;
    },
    cardIsAmex() {
      const ccNumber = this.creditCard.ccNumber;
      return (ccNumber && (ccNumber.substring(0, 2) === "34" || ccNumber.substring(0, 2) === "37"));
    },
    validCriteria() {
      let regex = /^\S+@\S+\.\S+$/;
      return !!(
        this.info.first_name &&
        this.info.last_name &&
        this.info.street_address &&
        this.info.state &&
        (this.info.postal_code && (this.info.postal_code.length === 5)) &&
        this.info.city &&
        regex.test(this.info.email) &&
        (this.info.phone_number && this.info.phone_number.length >= 10) &&
        (this.info.id_number && this.info.id_number.length > 2)
      );
    }
  },
  mounted() {
    this.$store.dispatch("getSettings");
  },
  watch: {
    speederentEnabled(speederentData) {
      if (speederentData) {
        this.speederentBtnEnabled = speederentData.value === "true";
      }
    }
  }
};
</script>
